import { MDBCol,MDBContainer, MDBRow } from 'mdbreact';
import React from 'react';
import Dropdown from './dropdown';


export default class navBar extends React.Component {
  

  render() {
    return (
      <nav className="navBar" style={{ marginBottom: "50px" }}>
        <MDBContainer>
          <MDBRow>
            <MDBCol xs="4"><h1 style={{ textAlign: "left", width: "150px" }}>Mitton Benjamin</h1></MDBCol>
            <MDBCol xs="4" style={{ width: "50px" }}></MDBCol>
            <MDBCol xs="4" style={{ width: "150px", textAlign: "right" }}> <Dropdown/> </MDBCol>
          </MDBRow>
        </MDBContainer>
        <div className="lignes">
          <div className="l1"></div>
          <div className="l2"></div>
        </div>
      </nav>
    
    );
  }

}